import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: "0" }
const _hoisted_2 = { class: "ml-4" }
const _hoisted_3 = { key: "1" }
const _hoisted_4 = { key: "0" }
const _hoisted_5 = { key: "0" }
const _hoisted_6 = { key: "0" }

import { computed, onMounted, ref } from "vue";
import { Filiale } from "@/models/filiale";
import { IsMobile } from "@/utils/Mobile";
import { useBookingStore } from "@/features/booking/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'FilialeSelector',
  props: {
    provincia: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const bookingStore = useBookingStore();

onMounted(() => {
  window.addEventListener("resize", () => {
    const c = document.getElementById("content") as HTMLElement;
    c.style.height = `${window.innerHeight - 400}px`;
  });
});

const search = ref("");

const filialiInProvincia = computed((): Array<Filiale> => {
  const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: "base",
  });

  return bookingStore.Filiali.filter(
    (f: Filiale) =>
      f.Provincia == props.provincia &&
      f.Citta.toLowerCase().includes(search.value.toLowerCase()),
  )
    .map((f: Filiale) => {
      f.Nome = f.Nome.replace(" Sede", " 0");
      return f;
    })
    .sort(
      (a: Filiale, b: Filiale) =>
        a.Citta.localeCompare(b.Citta) || collator.compare(a.Nome, b.Nome),
    )
    .map((f: Filiale) => {
      f.Nome = f.Nome.replace(" 0", " Sede");
      return f;
    });
});

function select(i: number, filiale: Filiale): void {
  emit("select", { filiale: filiale, pos: i + 1 });
}

const isMobile = computed((): boolean => IsMobile());

function IndirizzoShort(f: Filiale): string {
  if (!isMobile.value) {
    return f.Indirizzo;
  }

  return `${f.Indirizzo} (${f.Citta})`;
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "scrollable-content"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "4",
            "offset-md": "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: search.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                placeholder: "Filtra per Località",
                class: "mr-md-4",
                "prepend-icon": "mdi-map-search"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_expansion_panels, {
        variant: isMobile.value ? 'default' : 'popout'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel, { readonly: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "expand-icon": "",
                class: "hidden-sm-and-down"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("strong", null, "Nome", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("strong", null, "Indirizzo", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "hidden-sm-and-down"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("strong", null, "Località (Provincia)", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "1",
                        class: "hidden-sm-and-down"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("strong", null, "CAP", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filialiInProvincia.value, (e, i) => {
            return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: i }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, null, {
                  default: _withCtx(({ open }) => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_fade_transition, { "leave-absolute": "" }, {
                          default: _withCtx(() => [
                            open
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_1, [
                                      _createElementVNode("strong", _hoisted_2, _toDisplayString(e.Nome), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createBlock(_component_v_col, {
                                  key: 1,
                                  cols: "12",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(e.Nome), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4",
                          class: "text--secondary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_fade_transition, { "leave-absolute": "" }, {
                              default: _withCtx(() => [
                                (!open)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(IndirizzoShort(e)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          md: "3",
                          class: "text--secondary hidden-sm-and-down"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_fade_transition, { "leave-absolute": "" }, {
                              default: _withCtx(() => [
                                (!open)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(e.Citta) + " (" + _toDisplayString(e.Provincia) + ") ", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          md: "1",
                          class: "text--secondary hidden-sm-and-down"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_fade_transition, { "leave-absolute": "" }, {
                              default: _withCtx(() => [
                                (!open)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(e.CAP), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Indirizzo:", -1)),
                                    _createTextVNode(" " + _toDisplayString(e.Indirizzo), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Località:", -1)),
                                    _createTextVNode(" " + _toDisplayString(e.Citta) + " (" + _toDisplayString(e.Provincia) + ")", 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _cache[7] || (_cache[7] = _createElementVNode("strong", null, "CAP:", -1)),
                                    _createTextVNode(" " + _toDisplayString(e.CAP), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "8",
                          class: "mt-2 my-md-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "hidden-sm-and-down"
                                }, {
                                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                    _createElementVNode("strong", null, "Servizi Disponibili", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(e.Servizi, (s, j) => {
                                      return (_openBlock(), _createBlock(_component_v_chip, {
                                        key: j,
                                        class: "mr-1",
                                        "model-value": true
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(s), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          color: "#102a63",
                          onClick: ($event: any) => (select(i, e))
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode("Prenota", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["variant"])
    ]),
    _: 1
  }))
}
}

})